'use client';

import './NotFound.scss';
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function NotFound(data) {
  return (
    <div className="container not-found-component">
      <div className="rich-text-content">
        <RichText field={data?.fields?.content} />
      </div>
    </div>
  );
}
